
export function getActionData(actionType, payload = {}, error = {}) {
    return {type: actionType, payload, error};
}